export const toItemArray = (input: unknown) => {
  if (Array.isArray(input)) {
    return input;
  }

  return [input];
};
